import { render, staticRenderFns } from "./AlbumView.vue?vue&type=template&id=45fbda6a&scoped=true"
import script from "./AlbumView.vue?vue&type=script&lang=js"
export * from "./AlbumView.vue?vue&type=script&lang=js"
import style0 from "./AlbumView.vue?vue&type=style&index=0&id=45fbda6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fbda6a",
  null
  
)

export default component.exports